import ApiCaller from './ApiCaller/apiCaller'

export const getOffersDataByEan = (ean) => {
    return new Promise((resolve, reject) => {
            ApiCaller.get('/Catalog/Products/' + ean + '/OffersList.json?View=ProductSheet')
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
                console.error('ERROR', '/Catalog/Products/' + ean + '/OffersList.json?View=ProductSheet Api responded failed : ' + error)
                reject(error)
            });
    });
  };